import { render, staticRenderFns } from "./rsOrderDetail.vue?vue&type=template&id=364e42ae&scoped=true"
import script from "./rsOrderDetail.vue?vue&type=script&lang=js"
export * from "./rsOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./rsOrderDetail.vue?vue&type=style&index=0&id=364e42ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e42ae",
  null
  
)

export default component.exports